import React from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useToast,
} from "@chakra-ui/react";

import { useSelector, useDispatch } from "react-redux";

import { getProspects } from "../../redux/actions/prospectActions";

import axios from "../../utils/axios";

const DeleteModal = ({ isOpen, onOpen, onClose, text }) => {
  const delID = useSelector((state) => state.utils.delEdit);

  const dispatch = useDispatch();

  const toast = useToast();

  const handleDelete = async (delID) => {
    try {
      const res = await axios.delete(`/api/emails/delete_prospects/${delID}`);
      dispatch(getProspects());

      toast({
        title: res.data.msg,
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });

      onClose();

      // console.log(delID);
    } catch (error) {
      toast({
        title: error.data.msg,
        status: "danger",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{`Delete ${text}`}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{`Are you sure you want to delete ${text}?`}</ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={() => handleDelete(delID)}>
            Delete
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
